import { paths } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';

import { DYNAMIC_TAG_NAMES } from '@interlayer/js/custom/utils/constants';

export const useDynamicTags = (dynamicTags: DYNAMIC_TAG_NAMES[]): (string | undefined)[] => useAppSelector(
    paths(dynamicTags.map(tag => ['dynamicTags', `DTAG_${tag}`]))
);
